import { POMP_STEP_STATE, SELECT_ADDRESS_STEP_STATE } from "@stadium/checkout/src/constants/order";

export const getCheckoutStepsInitState = ({
  checkoutSteps,
  defaultCompletedSteps,
  optionalSteps,
}) =>
  checkoutSteps.reduce((acc, stepKey, index) => {
    acc[stepKey] = {
      key: stepKey,
      position: index,
      submitted: defaultCompletedSteps.includes(stepKey),
      optional: optionalSteps.includes(stepKey),
    };
    return acc;
  }, {});

export const getNextCheckoutStep = (currentCheckoutStep, checkoutStepsState) => {
  const sortedSteps = Object.values(checkoutStepsState).sort((a, b) => a.position - b.position);
  const currentPosition = checkoutStepsState[currentCheckoutStep].position;
  const nextStep = sortedSteps.find((step) => step.position > currentPosition && !step.submitted);
  return nextStep?.key || null;
};

export const getOrderDefaultCompletedSteps = (orderData, checkoutStepsState) => {
  const defaultCompletedSteps = [];

  if (orderData.shipAddressId !== null) {
    defaultCompletedSteps.push(SELECT_ADDRESS_STEP_STATE);
  }

  if (orderData.hasPomp !== null) {
    defaultCompletedSteps.push(POMP_STEP_STATE);
  }

  Object.entries(checkoutStepsState).forEach(([stepKey, stepState]) => {
    if (stepState.submitted) {
      defaultCompletedSteps.push(stepKey);
    }
  });

  return defaultCompletedSteps;
};

export const isCreditCardExpired = ({ month, year }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const cardMonth = parseInt(month, 10);
  const cardYear = parseInt(year, 10);

  if (cardYear < currentYear) return true;
  if (cardYear === currentYear && cardMonth < currentMonth) return true;

  return false;
};
